var React = require('react');

function Arrowlinkblack (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13.8034 1.28205H0V0L15 0V15H13.8034V1.28205Z","fill":"#202020","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 14.1092L14.1092 0L15 0.890779L0.890779 15L0 14.1092Z","fill":"#202020","key":1})]);
}

Arrowlinkblack.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none"};

module.exports = Arrowlinkblack;

Arrowlinkblack.default = Arrowlinkblack;
